import { creditsUnlockTypes } from './types';
import { newDate } from "helpers/dateTools";

const {
  HANDLE_CREDITS_UNLOCK_INPUTS,
  GET_CREDITS_UNLOCK,
  ADD_CREDITS_UNLOCK,
  CHANGE_STATUS_CREDIT_UNLOCK,
  DELETE_CREDITS_UNLOCK,
  CHECK_CREDIT_UNLOCK_SETTINGS,
  CLEAN_EXISTS,
  RESTORE_INITIAL,
} = creditsUnlockTypes;

const initialState = {
  creditsUnlock: [],
  station: [],
  startDate: newDate(),
  endDate: newDate(),
  customersOpt: [],
  searchCustomer: {},
  customer: {},
  comments: "",
  requestCredit: false,
};

export const creditsUnlockReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_CREDITS_UNLOCK_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case GET_CREDITS_UNLOCK: {
      const mapDataCredits = payload.map(item =>
      ({
        ...item, 
        colorStatus: item.status_ticket === "APROBADO" ? "success" :
          item.status_ticket === "RECHAZADO" ? "error" : "info",
        serviceStatus: item?.id_service ? "Utilizado" : item?.status_ticket === "APROBADO" ? "Disponible": "",
      }))
      return { ...state, creditsUnlock: mapDataCredits };
    }
    case ADD_CREDITS_UNLOCK:
      return {
        ...state,
        creditsUnlock: [...state.creditsUnlock, payload],
        comments: "",
      };
    case CHANGE_STATUS_CREDIT_UNLOCK: {
      const mapCreditsUnlock = state.creditsUnlock.map(item => item.id === payload.id ? { ...item, ...payload } : item)
      return {
        ...state,
        creditsUnlock: mapCreditsUnlock
      };
    }
    case DELETE_CREDITS_UNLOCK:
      return { ...state, creditsUnlock: state.creditsUnlock.filter(item => item.id !== payload) };
    case CHECK_CREDIT_UNLOCK_SETTINGS:
      return { ...state, requestCredit: payload }
    case CLEAN_EXISTS:
      return { ...state, requestCredit: false }
    case RESTORE_INITIAL:
      return {
        ...initialState
      }
    default:
      return state;
  }
};